import { createRoot } from 'react-dom/client';
import { initLogger, initRum } from '@carboncopyco/logger';

import { App } from './app';
import { settings } from '../../settings';

if (
  process.env.NODE_ENV !== 'development' ||
  settings?.DD_LOGS_SEND_RENDERER_LOCAL_LOGS
) {
  initLogger({
    clientToken: settings.DD_CLIENT_API_KEY,
    service: 'desktop-app',
    forwardErrorsToLogs: true,
    forwardConsoleLogs: 'all',
    sessionSampleRate: 100,
    env: settings.SEGMENT_SOURCE,
    version: settings.npm_package_version,
  });
  initRum({
    clientToken: settings.DD_CLIENT_API_KEY,
    applicationId: '4d18c729-f0ed-4e13-af1b-eb12161a529e',
    env: settings.SEGMENT_SOURCE,
    version: settings.npm_package_version,
    sessionSampleRate: 100,
    trackUserInteractions: true,
    trackViewsManually: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

const container = document?.getElementById('root') ?? null;
if (!container) {
  throw new Error('No root element found');
}
const root = createRoot(container);
root.render(<App />);
